module.exports = __webpack_public_path__ + "static/media/18pulgadasaceroinox.73bdd21a.jpg";